







































import CFMDialog from '@/scripts/CFMDialog'
import {Component} from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'

import {required} from "vuelidate/lib/validators";

import {CFMDTOProductFamily } from '@/scripts/services/ClientApiAuto'

@Component<ProductFamilyDialog>({
    validations() {
        return {
          productFamily:{
              Name: {required}
          }
        }
    },
})
export default class ProductFamilyDialog extends CFMDialog {
    productFamily: CFMDTOProductFamily = {Name: ''};

    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.productFamily.productFamilyGetById({id: <number>this.id});
        this.productFamily = res.data;
      }
      blockui.unBlockModal();
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      let formData = {
        Id: this.productFamily.Id,
        Name: this.productFamily.Name,
      };
      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.productFamily.productFamilySave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
